import { render, staticRenderFns } from "./EnergyRing.vue?vue&type=template&id=faf541b2&scoped=true"
import script from "./EnergyRing.vue?vue&type=script&lang=js"
export * from "./EnergyRing.vue?vue&type=script&lang=js"
import style0 from "./EnergyRing.vue?vue&type=style&index=0&id=faf541b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf541b2",
  null
  
)

export default component.exports